<template>
  <span>
    <span :class="state.color">● </span>
    <span>{{ state.value }}</span>
  </span>
</template>

<script>
export default {
  props: ['type'],
  computed: {
    state() {
      switch (this.type) {
        case 1:
          return {
            value: '待送检',
            color: 'gray',
          }
        case 2:
          return {
            value: '已送检',
            color: 'blue',
          }
        case 3:
          return {
            value: '撤销',
            color: 'green',
          }
        case 4:
          return {
            value: '待确认',
            color: 'red',
          }
        case 5:
          return {
            value: '已完成',
            color: 'yellow',
          }
        default:
          return {
            value: '',
            color: '',
          }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.gray {
  color: #BFBFBF
}
.blue {
  color: #0E77D1
}
.green {
  color: #00A854
}
.red {
  color: #F04134
}
.yellow {
  color: #FFBF00
}
</style>


// WEBPACK FOOTER //
// src/views/VertifyOrder/components/statusCom.vue